import '../CSS/Global.css';
import GroupedStackedBarChart from './ProjectBar';
import { useSidebar } from '../SidebarContext';
import Header from './Header'
import Sidebar from './SideBar';


function EmployeePerformance() {
    const { isSidebarOpen } = useSidebar();
    return (
        <>
       
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="performance-cards">
                    <div className="performance-card-list">
                        <i className="fas fa-users performance-icon"></i>
                        <div className="performance-label-card">
                            <p className="performance-label">Total Employee</p>
                            <p className="no-of-days">50</p>
                        </div>
                    </div>
                    <div className="performance-card-list">
                        <i className="fa-solid fa-indian-rupee-sign performance-icon"></i>
                        <div className="performance-label-card">
                            <p className="performance-label">Gross Salary</p>
                            <p className="no-of-days">₹ 90,000</p>
                        </div>
                    </div>
                    <div className="performance-card-list">
                        <i className="fas fa-chart-line performance-icon"></i>
                        <div className="performance-label-card">
                            <p className="performance-label">Net Payable</p>
                            <p className="no-of-days">₹ 75,000</p>
                        </div>
                    </div>
                    <div className="performance-card-list">
                        <i className="fas fa-tasks performance-icon"></i>
                        <div className="performace-label-card">
                            <p className="performance-label">Total Tasks</p>
                            <p className="no-of-days">120</p>
                        </div>
                    </div>
                </div>

                <GroupedStackedBarChart />
            </div>
        </>
    );
}

export default EmployeePerformance;
